export const DIGIT_SCAN_MIN_LENGTH = 5;
export const ALPHANUMERIC_SCAN_MIN_LENGTH = 8;
export const SCAN_IDLE_THRESHOLD_MS = 100;
export const SCAN_BURST_MAX_DURATION_MS = 90;
export const SCAN_AUTO_MIN_LENGTH = 15;

export type ScanBurstState = {
  startTime: number;
  lastTime: number;
  length: number;
  timeoutId: number | null;
};

export const createScanBurstState = (): ScanBurstState => ({
  startTime: 0,
  lastTime: 0,
  length: 0,
  timeoutId: null,
});

export const sanitizeScanCandidate = (value: string): string => value.trim().replace(/[\s-]+/g, '');

export const normalizeScanKey = (value?: string | null): string => {
  if (!value) {
    return '';
  }
  const normalized = sanitizeScanCandidate(String(value));
  return normalized ? normalized.toUpperCase() : '';
};

export const looksLikeScanCode = (value: string): boolean => {
  const compact = sanitizeScanCandidate(value);
  if (compact.length < DIGIT_SCAN_MIN_LENGTH) {
    return false;
  }
  if (/^\d+$/.test(compact)) {
    return true;
  }
  return compact.length >= ALPHANUMERIC_SCAN_MIN_LENGTH && /^[A-Z0-9]+$/i.test(compact);
};
